/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { DeleteCourseActivityOptions, DeleteCourseActivityResponses } from '../../models/DeleteCourseActivity'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Delete Course Activity
 * {@link /admin/course/activity/:activity_id}
 */
export function deleteCourseActivity<ThrowOnError extends boolean = true>(options: Options<DeleteCourseActivityOptions, ThrowOnError>): Promise<UnwrappedResult<DeleteCourseActivityResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'DELETE', url: '/admin/course/activity/{activity_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<DeleteCourseActivityResponses, ThrowOnError>>
}
